import React,{Component} from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { ForgotPassword } from '../../actions/userAction';
import { Control } from 'react-redux-form';
import {mediaPath } from "../../config";

const validateSchema=Yup.object().shape({
	email: Yup.string()
		.email('Please enter a valid email address.')
		.required('Please enter your email address.'),
});

class forgotPassword extends Component {
	componentDidMount() {}
	render(){
		return (
			<div className="login-block" role="main">
				<div className="login-inner-wrapper">
					<div className="logo"><a onClick={()=>{
										this.props.history.push('/login');
									}}><img src={mediaPath+"osah-logo.png"} alt="OSAH Georgia office of state administrative hearings" /></a></div>
					<div className="reset-your-osah-password-section">
						<h1 tabIndex="0" aria-label="Reset Your OSAH Password" className="title">Reset Your OSAH Password</h1>
						<p className="subtitle">Submit your email address and we will send you a link to reset your password.</p>
						<div className="email-block">
							<label aria-label="Enter email">Email*
								<Control.text model="forgotPassword.email" value={this.props.forgotPassword.email.trim()}/>
							</label>
						</div>
						<div className="btn-block">
							<button className="submit-btn" onClick={()=>{this.props.ForgotPassword(this.props.forgotPassword,validateSchema)}}>Submit</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
  return {
	  forgotPassword : state.forgotPassword,
	  uiState : state.uiState
  };
}

export default connect(mapStateToProps,{ForgotPassword})(forgotPassword);